import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=4fc8f753&scoped=true"
import script from "./Column.vue?vue&type=script&lang=ts"
export * from "./Column.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Column.vue?vue&type=style&index=0&id=4fc8f753&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4fc8f753",
  "3f1125b7"
  
)

export default component.exports